export default __webpack_public_path__ + "code_icon.8b81cb.svg";